import { Component, computed, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeadermenuComponent } from './components/headermenu/headermenu.component';
import { TenantsService } from './core/services/tenants.service';
import { NSLoginService } from './Clients/NS/Services/NSLogin.service';
import { Store } from '@ngrx/store';
import { UserLoginComponent } from "./components/user-login/user-login.component";
import { versionInfo } from '../environments/version';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeadermenuComponent, UserLoginComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'TravelofficeUI';
  token = signal<string>('');
  CompanyId = signal<string>('');
  constructor(
    private tanentser: TenantsService,
    public nslogin: NSLoginService
  ) {
    console.log(`🚀 current Deployment hash:  [${versionInfo.hash}] - ${versionInfo.timestamp}`);
    const t = this.nslogin.gettoken();
    this.token.set(t);
    this.nslogin.LoginwithToken(t);
    this.CompanyId.set(this.tanentser.getTenantFromSubdomain());
  }
  ngOnInit(): void {

  }

  showheader = computed(() => {
    return this.nslogin.isLoggedIn() && this.CompanyId().length > 0;
  });

}
